/* Fairway & Greene · Holiday 2026 takeover
   One script, scoped to html.tk-on. Reads #tk-config, picks the live campaign
   by date (Central time offsets live in the config), and renders the offer bar,
   promo band, product card lines, product page module and bag summary.
   Nothing here changes how Shopify prices the bag; it only explains it. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('tk-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var html = document.documentElement;
  var T0 = Date.now();
  var PREVIEW = C.preview ? Date.parse(C.preview) : NaN;

  /* ---------- time ---------- */
  function now() { return isNaN(PREVIEW) ? Date.now() : PREVIEW + (Date.now() - T0); }
  function ts(s) { var t = Date.parse(s); return isNaN(t) ? NaN : t; }
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  // Calendar date as written in the setting (Central), not the shopper's clock.
  function longDate(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
    return m ? MONTHS[+m[2] - 1] + ' ' + (+m[3]) : '';
  }
  function countdown(ms) {
    if (ms <= 0) return '';
    var m = Math.floor(ms / 60000), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    if (d >= 1) return d + 'd ' + h + 'h';
    return h + 'h ' + (mm < 10 ? '0' : '') + mm + 'm';
  }

  /* ---------- money ---------- */
  function money(cents) {
    var v = Math.round(cents) / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function after(cents, pct) { return Math.round(cents * (100 - pct) / 100); }
  function stackOff(mdPerMille, pct) { // total % off original when an extra pct lands on a markdown
    var md = mdPerMille / 1000;
    return Math.round((1 - (1 - md) * (1 - pct / 100)) * 1000) / 10;
  }
  function pctText(x) { return (x % 1 === 0 ? x.toFixed(0) : x.toFixed(1)) + '%'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- campaigns ---------- */
  var TIERS = String(C.tiers || '').split(',').map(function (p) {
    var a = p.split(':'); return { qty: +a[0], pct: +a[1] };
  }).filter(function (t) { return t.qty > 0 && t.pct > 0; }).sort(function (a, b) { return a.qty - b.qty; });
  var CAMPS = (C.campaigns || []).map(function (c) {
    c.s = ts(c.start); c.e = ts(c.end);
    c.handles = String(c.handles || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    return c;
  });
  function activeAt(t) {
    var main = null, ship = null;
    CAMPS.forEach(function (c) {
      if (!(c.s <= t && t <= c.e)) return;
      if (c.kind === 'shipping') { ship = ship || c; return; }
      if (!main) main = c;
    });
    return { main: main || (ship ? ship : null), ship: ship };
  }
  var STATE = activeAt(now());
  var MAIN = STATE.main;
  function sub(c, text) {
    return String(text || '').replace('{end}', longDate(c.end)).replace('{code}', c.code || '');
  }
  function sitewidePct() { return MAIN && (MAIN.kind === 'sitewide' || MAIN.kind === 'code') ? MAIN.pct : 0; }
  function pcLive() { return C.pc && C.pc.code && now() <= ts(C.pc.end); }
  function tierFor(n) { var r = null; TIERS.forEach(function (t) { if (n >= t.qty) r = t; }); return r; }
  function nextTier(n) { for (var i = 0; i < TIERS.length; i++) if (TIERS[i].qty > n) return TIERS[i]; return null; }
  function cookieCode() {
    var m = /(?:^|;\s*)discount_code=([^;]+)/.exec(document.cookie);
    return m ? decodeURIComponent(m[1]).toUpperCase() : '';
  }

  if (MAIN) html.classList.add('tk-c-' + MAIN.id);
  if (MAIN && MAIN.kind === 'sitewide') html.classList.add('tk-autosale');
  if (C.pass) html.classList.add('tk-pass');

  /* ---------- bag ---------- */
  var BAG = null;
  function bagElig(b) {
    if (!b) return 0;
    return b.items.reduce(function (n, i) { return n + (i.elig ? i.qty : 0); }, 0);
  }
  // Shopify answers /cart with its own cart JSON (no eligibility, different field names) whenever the
  // request asks for JSON, so the takeover view is requested as plain text, and anything that still
  // comes back in cart.js shape is normalised instead of showing NaN or undefined.
  function normBag(b) {
    if (!b || !b.items) return b;
    b.items = b.items.map(function (i) {
      if (typeof i.qty === 'number') return i;
      var tags = [], disc = (i.line_level_discount_allocations || []).reduce(function (a, d) { return a + (d.amount || 0); }, 0);
      var service = /re:?do/i.test(i.vendor || '');
      return { key: i.key, title: i.product_title || i.title, qty: i.quantity, price: i.original_price, compare: 0, line: i.original_line_price,
        final_line: i.final_line_price, line_discount: disc, elig: !i.gift_card && !service, service: service, bundle: false, pc: false,
        gift_card: !!i.gift_card, handles: [], variant_id: i.variant_id, product_id: i.product_id, url: i.url, image: i.image || '',
        variant_title: i.variant_title || '', single_variant: !!i.product_has_only_default_variant, final_price: i.final_price,
        discount_titles: (i.discounts || []).map(function (d) { return d.title; }),
        props: Object.keys(i.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && i.properties[k]; }).map(function (k) { return { k: k, v: i.properties[k] }; }),
        available_qty_max: 99 };
    });
    b.codes = b.codes || []; b.cart_level_discounts = b.cart_level_discounts || [];
    return b;
  }
  function loadBag() {
    return fetch('/cart?view=tk&_=' + Date.now(), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (t) { BAG = normBag(JSON.parse(t)); renderAll(); renderBagModal(); })
      .catch(function () { /* the takeover only explains offers; fail quietly */ });
  }
  var bagTimer;
  function refreshBag() { clearTimeout(bagTimer); bagTimer = setTimeout(loadBag, 250); }
  // Hear every bag change: theme pub/sub where present, plus any fetch to /cart/*.
  try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshBag); } catch (e) {}
  var _f = window.fetch;
  if (window.fetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _f.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refreshBag, refreshBag);
      return p;
    };
  }

  /* ---------- preview line ---------- */
  function renderPreview() {
    var el = document.querySelector('[data-tk-preview]');
    if (!el || isNaN(PREVIEW)) return;
    var label = MAIN ? (MAIN.wordmark || MAIN.headline) : 'No offer live';
    el.hidden = false;
    el.textContent = 'PREVIEW · ' + label + (STATE.ship && STATE.ship !== MAIN ? ' + free 2-day shipping' : '') + ' · as of ' + longDate(C.preview);
  }

  /* ---------- offer bar ---------- */
  function offerLabel() {
    if (!MAIN) return { title: 'Bundle and save ' + C.bundle.pct + '%', note: 'Curated sets, priced together', url: C.bundle.url };
    if (MAIN.kind === 'tiers') {
      var top = TIERS[TIERS.length - 1];
      return { title: 'Up to ' + top.pct + '% off when you buy more', note: TIERS.map(function (t) { return t.qty + (t === top ? '+' : '') + ' for ' + t.pct + '%'; }).join(', '), url: MAIN.url };
    }
    if (MAIN.kind === 'collection') return { title: MAIN.pct + '% off gifts for the golfer', note: 'Applied automatically', url: MAIN.url };
    if (MAIN.kind === 'code') return { title: MAIN.pct + '% early access', note: 'Code ' + MAIN.code, url: MAIN.url };
    if (MAIN.kind === 'shipping') return { title: 'Free 2-day shipping', note: 'On orders of ' + money(MAIN.threshold) + ' or more', url: MAIN.url };
    return { title: MAIN.pct + '% off sitewide', note: 'Applied automatically in your bag', url: MAIN.url };
  }
  function renderBar() {
    var o = document.querySelector('[data-tk-bar-offer]');
    var p = document.querySelector('[data-tk-bar-progress]');
    var s = document.querySelector('[data-tk-bar-ship]');
    if (!o) return;
    var L = offerLabel();
    var left = MAIN ? MAIN.e - now() : 0;
    o.innerHTML =
      '<a class="tk-bar__title" href="' + esc(L.url) + '">' + esc(L.title) + '</a>' +
      '<span class="tk-bar__note">' + esc(L.note) + '</span>' +
      (MAIN && left > 0 && left < 7 * 864e5 ? '<span class="tk-bar__clock" data-tk-clock>Ends in ' + countdown(left) + '</span>' : '') +
      '<button type="button" class="tk-bar__details" data-tk-details-open>Offer details</button>';

    // progress column
    if (p) {
      var n = bagElig(BAG), html2 = '';
      if (MAIN && MAIN.kind === 'tiers') {
        var cur = tierFor(n), nx = nextTier(n);
        var maxQ = TIERS[TIERS.length - 1].qty;
        html2 = '<span class="tk-bar__ptext">' + (cur ? '<strong>' + cur.pct + '% off</strong> on ' + n + ' pieces' : 'Your bag: ' + n + (n === 1 ? ' piece' : ' pieces')) +
          (nx ? ' · add ' + (nx.qty - n) + ' for ' + nx.pct + '%' : ' · best price reached') + '</span>' +
          '<span class="tk-meter" aria-hidden="true"><i style="width:' + Math.min(100, n / maxQ * 100) + '%"></i></span>';
      } else if (MAIN && MAIN.kind === 'code') {
        var has = cookieCode() === String(MAIN.code).toUpperCase() || (BAG && BAG.codes.indexOf(MAIN.code) > -1);
        html2 = '<span class="tk-bar__ptext">' + (has ? '<strong>Code ' + esc(MAIN.code) + ' is applied</strong>' : 'Use code <strong>' + esc(MAIN.code) + '</strong> at checkout') + '</span>';
      } else if (MAIN && (MAIN.kind === 'sitewide' || MAIN.kind === 'collection')) {
        var saved = BAG ? BAG.total_discount : 0;
        html2 = '<span class="tk-bar__ptext">' + (saved > 0 ? 'You are saving <strong>' + money(saved) + '</strong>' : 'No code needed') + '</span>';
      }
      p.innerHTML = html2;
      p.hidden = !html2;
    }

    // shipping column
    if (s) {
      var th = STATE.ship ? STATE.ship.threshold : C.freeShip, what = STATE.ship ? 'free 2-day shipping' : 'free U.S. shipping';
      var tot = BAG ? BAG.total_price : 0, gap = th - tot;
      s.innerHTML = '<span class="tk-bar__ptext">' + (BAG && gap <= 0 ? '<strong>You have ' + what + '</strong>' : (BAG && tot > 0 ? money(gap) + ' from ' + what : capital(what) + ' on orders of ' + money(th) + '+')) + '</span>' +
        '<span class="tk-meter" aria-hidden="true"><i style="width:' + Math.min(100, th ? tot / th * 100 : 0) + '%"></i></span>';
    }
  }
  function capital(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  /* ---------- offer details ---------- */
  function renderDetails() {
    var body = document.querySelector('[data-tk-details-body]');
    if (!body) return;
    var t = now(), rows = '';
    CAMPS.forEach(function (c) {
      if (c.e < t) return;
      var live = c.s <= t;
      var what = c.kind === 'tiers' ? TIERS.map(function (x) { return x.pct + '% off ' + x.qty + (x === TIERS[TIERS.length - 1] ? ' or more' : '') + ' pieces'; }).join(', ')
        : c.kind === 'shipping' ? 'Free 2-day shipping on U.S. orders of ' + money(c.threshold) + ' or more'
        : c.kind === 'code' ? c.pct + '% off with code ' + c.code
        : c.kind === 'collection' ? c.pct + '% off the gifts for the golfer collection'
        : c.pct + '% off sitewide, applied automatically';
      rows += '<li class="tk-details__row' + (live ? ' is-live' : '') + '"><span class="tk-details__when">' + (live ? 'Now through ' + longDate(c.end) : longDate(c.start) + ' to ' + longDate(c.end)) + '</span><span class="tk-details__what">' + esc(what) + '</span></li>';
    });
    body.innerHTML =
      '<ul class="tk-details__list">' + rows + '</ul>' +
      '<p class="tk-details__fine">Bundles are ' + C.bundle.pct + '% off all season. ' +
      (pcLive() ? 'The Presidents Cup collection is ' + C.pc.pct + '% off with code ' + esc(C.pc.code) + '. ' : '') +
      'Sitewide offers exclude corporate and team collections, bundles, the Presidents Cup collection and gift cards. Pieces already on sale take the extra percentage on their sale price. Offers end at 11:59 pm Central on the dates shown and cannot be applied to past orders.</p>';
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-tk-details-open]');
    var close = e.target.closest && e.target.closest('[data-tk-details-close]');
    var dlg = document.querySelector('[data-tk-details]');
    if (!dlg) return;
    if (open) { renderDetails(); if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
    if (close || e.target === dlg) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  });

  /* ---------- promo band ---------- */
  // Buy More, Save More (tier offer): the gold script-serif neon banner. Static glow, nothing blinks.
  function renderNeon(el, c) {
    var n = bagElig(BAG), cur = tierFor(n), nx = nextTier(n), last = TIERS[TIERS.length - 1];
    var status = !n ? 'Mix and match any style'
      : (cur ? n + (n === 1 ? ' piece' : ' pieces') + ' in your bag: ' + cur.pct + '% off' : n + ' piece in your bag') +
        (nx ? '. Add ' + (nx.qty - n) + ' more for ' + nx.pct + '% off' : '. Best price reached');
    el.className = 'tk-band tk-band--neon' + (el.classList.contains('is-compact') ? ' is-compact' : '');
    el.innerHTML = '<div class="tk-neon">' +
      '<p class="tk-neon__title" role="heading" aria-level="2">Buy More, Save More</p>' +
      '<ul class="tk-neon__tiers" aria-label="Savings by number of pieces">' + TIERS.map(function (t) {
        return '<li class="tk-neon__tier' + (cur === t ? ' is-current' : '') + (n >= t.qty ? ' is-reached' : '') + '">' +
          '<span class="tk-neon__buy">Buy ' + t.qty + (t === last ? '+' : '') + '</span><span class="tk-neon__pct">' + t.pct + '% off</span></li>';
      }).join('') + '</ul>' +
      '<p class="tk-neon__meta"><span>' + esc(status) + '</span><span>Through ' + esc(longDate(c.end)) + '</span>' +
      '<button type="button" class="tk-neon__link" data-tk-details-open>Offer details</button></p></div>';
  }
  function renderBand() {
    var el = document.querySelector('[data-tk-band]');
    if (!el || C.pass) return;
    var c = MAIN;
    if (c && c.kind === 'tiers') { renderNeon(el, c); return; }
    var theme = !c ? 'bundle' : c.kind === 'tiers' ? 'tiers' : c.kind === 'collection' ? 'gftg' : c.id;
    el.className = 'tk-band tk-band--' + theme + (el.classList.contains('is-compact') ? ' is-compact' : '');
    var word = c && c.wordmark ? '<p class="tk-band__word" aria-hidden="true">' + esc(c.wordmark) + '</p>' : '';
    var head = c ? c.headline : 'Bundle and save ' + C.bundle.pct + '%';
    var compact = el.classList.contains('is-compact');
    var subl = c ? sub(c, c.sub) : 'Curated sets of our most-worn pieces, priced together all season.';
    if (compact && c && c.kind === 'tiers') subl = TIERS.map(function (t) { return t.qty + (t === TIERS[TIERS.length - 1] ? '+' : '') + ' for ' + t.pct + '%'; }).join(' \u00b7 ') + '. Through ' + longDate(c.end) + '.';
    var left = c ? c.e - now() : 0;
    var clock = compact && c && left > 0 && left < 7 * 864e5 ? '<span class="tk-band__clock" data-tk-clock>Ends in ' + countdown(left) + '</span>' : '';
    var cta = c ? '<a class="tk-band__cta" href="' + esc(c.url) + '">' + esc(c.cta) + '</a>' : '<a class="tk-band__cta" href="' + esc(C.bundle.url) + '">Shop bundles</a>';
    var ladder = '';
    if (c && c.kind === 'tiers') {
      var n = bagElig(BAG), cur = tierFor(n), nx = nextTier(n);
      ladder = '<ol class="tk-ladder" aria-label="Savings by number of pieces">' + TIERS.map(function (t) {
        var reached = n >= t.qty, isCur = cur === t, isNext = nx === t;
        return '<li class="tk-ladder__step' + (reached ? ' is-reached' : '') + (isNext ? ' is-next' : '') + '">' +
          (isCur ? '<span class="tk-ladder__tag">You\u2019re here</span>' : isNext ? '<span class="tk-ladder__tag tk-ladder__tag--next">+' + (t.qty - n) + (t.qty - n === 1 ? ' piece' : ' pieces') + '</span>' : '') +
          '<span class="tk-ladder__pct">' + t.pct + '%</span><span class="tk-ladder__qty">' + t.qty + (t === TIERS[TIERS.length - 1] ? '+' : '') + ' pieces</span></li>';
      }).join('') + '</ol>';
    }
    var archive = '';
    if (c && (c.kind === 'sitewide' || c.kind === 'code')) {
      archive = '<p class="tk-band__aside">Sale pieces take the extra ' + c.pct + '% too. <a href="/collections/sale">Shop the sale</a></p>';
    }
    el.innerHTML = '<div class="tk-band__inner">' + word +
      '<h2 class="tk-band__head">' + esc(head) + '</h2>' +
      '<p class="tk-band__sub">' + esc(subl) + '</p>' + ladder +
      '<div class="tk-band__actions">' + clock + cta + '<button type="button" class="tk-band__link" data-tk-details-open>Offer details</button></div>' + archive +
      '</div>';
  }

  /* ---------- product cards ---------- */
  function cardLine(d) {
    var pct = 0, how = 'in your bag';
    var cols = (d.cols || '').split(',').filter(Boolean);
    if (d.corp === 'true') return '';
    if (d.pc === 'true') return pcLive() ? '<span class="tk-card__lead">' + C.pc.pct + '% off with code ' + esc(C.pc.code) + '</span>' : '';
    if (d.bundle === 'true') return '<span class="tk-card__lead">Bundle and save ' + C.bundle.pct + '%</span>';
    if (!MAIN || d.elig !== 'true') return '';
    if (MAIN.kind === 'tiers') {
      var top = TIERS[TIERS.length - 1];
      var extra = d.hasfull !== 'true' ? 'An extra ' : 'Up to ';
      return '<span class="tk-card__lead">' + extra + (d.hasfull !== 'true' ? 'up to ' : '') + top.pct + '% off</span><span class="tk-card__sub">' + (d.hasfull !== 'true' ? 'on the sale price, ' : '') + 'when you buy ' + top.qty + ' or more pieces</span>';
    }
    if (MAIN.kind === 'collection') { if (!cols.length) return ''; pct = MAIN.pct; }
    else if (MAIN.kind === 'code') { pct = MAIN.pct; how = 'with code ' + MAIN.code; }
    else if (MAIN.kind === 'sitewide') pct = MAIN.pct;
    else return '';
    // One price row (was, now) replaces the theme price, plus one short note on how the price applies.
    // "Up to" figures round down so the card never promises more than the bag gives.
    var full = +d.full, min = +d.min, md = +d.maxmd, upTo = Math.floor(stackOff(md, pct)) + '%';
    if (d.hasfull === 'true') {
      return '<span class="tk-card__price"><s>' + money(full) + '</s><strong>' + money(after(full, pct)) + '</strong></span>' +
        '<span class="tk-card__sub">' + pct + '% off ' + esc(how) + (d.hasmd === 'true' && md > 0 ? ' · sale colors up to ' + upTo : '') + '</span>';
    }
    return '<span class="tk-card__price"><span class="tk-card__from">From</span><s>' + money(min) + '</s><strong>' + money(after(min, pct)) + '</strong></span>' +
      '<span class="tk-card__sub">Extra ' + pct + '% off sale ' + esc(how) + ' · up to ' + upTo + ' off</span>';
  }
  function niceColorLabels(root) {
    (root || document).querySelectorAll('.pd-selected-color-value:not([data-tk-nice])').forEach(function (p) {
      p.textContent = niceVariant(p.textContent); p.setAttribute('data-tk-nice', '');
    });
  }
  function renderCards(root) {
    if (!C.pass) niceColorLabels(root);
    (root || document).querySelectorAll('[data-tk-card]').forEach(function (el) {
      if (!C.pass && el.dataset.corp === 'true') { // safety net: a corporate piece that slipped into a shared row or grid
        var item = el.closest('.tk-row__item, .tk-grid__item, .grid__item, li'); if (item) { item.hidden = true; item.style.display = 'none'; }
        return;
      }
      var h = cardLine(el.dataset);
      el.innerHTML = h;
      el.hidden = !h;
      el.toggleAttribute('data-tk-price', h.indexOf('tk-card__price') > -1);
    });
  }

  /* ---------- product page ---------- */
  var PDP = { el: null, variants: [], vid: null };
  function currentVariantId() {
    var forms = document.querySelectorAll('product-information form[action*="/cart/add"] [name="id"], #MainContent > .shopify-section:first-child form[action*="/cart/add"] [name="id"]');
    if (!forms.length) forms = document.querySelectorAll('#MainContent form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.offsetParent !== null || f.type === 'hidden') { if (f.value) return +f.value; }
    }
    var u = new URLSearchParams(location.search).get('variant');
    return u ? +u : (PDP.variants[0] && PDP.variants[0].id);
  }
  function renderPdp() {
    var roots = document.querySelectorAll('[data-tk-pdp]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      var d = root.dataset;
      var vj = root.querySelector('[data-tk-variants]');
      var vs = []; try { vs = JSON.parse(vj.textContent); } catch (e) {}
      PDP.variants = vs;
      var id = currentVariantId();
      var v = vs.filter(function (x) { return x.id === id; })[0] || vs[0];
      var off = root.querySelector('[data-tk-pdp-offer]'), del = root.querySelector('[data-tk-pdp-delivery]');
      if (off) off.innerHTML = v ? pdpOffer(d, v) : '';
      if (del) del.innerHTML = pdpDelivery(d);
      root.hidden = !(off && off.innerHTML) && !(del && del.innerHTML);
      root.toggleAttribute('data-tk-price', !!(off && off.querySelector('.tk-pdp__price'))); // our price row stands in for the theme price

    });
  }
  function pdpOffer(d, v) {
    if (d.corp === 'true' || C.pass) return '';
    if (d.pc === 'true') return ''; // the live Presidents Cup block already explains PRESCUP
    if (d.bundle === 'true') return '<div class="tk-pdp__price"><s>' + money(v.p) + '</s> <strong>' + money(after(v.p, C.bundle.pct)) + '</strong><span class="tk-pdp__save">Save ' + C.bundle.pct + '%</span></div><p class="tk-pdp__how">Bundle and save, applied automatically in your bag.</p>';
    if (!MAIN || d.elig !== 'true') return '';
    var marked = v.c > v.p;
    if (MAIN.kind === 'tiers') {
      var n = bagElig(BAG) + 1, cur = tierFor(n), nx = nextTier(n);
      var lead = n < TIERS[0].qty
        ? 'Add this and ' + (TIERS[0].qty - n) + ' more, any style, for ' + TIERS[0].pct + '% off'
        : 'With this piece your bag reaches ' + n + ' pieces: ' + cur.pct + '% off each' + (nx ? '. One more for ' + nx.pct + '%' : '');
      return '<p class="tk-pdp__lead">' + esc(lead) + '</p><ol class="tk-strip" aria-label="Price of this piece by number of pieces">' + TIERS.map(function (t) {
        var hit = cur === t;
        return '<li class="tk-strip__seg' + (hit ? ' is-hit' : '') + (n >= t.qty && !hit ? ' is-past' : '') + '"><span class="tk-strip__qty">' + t.qty + (t === TIERS[TIERS.length - 1] ? '+' : '') + ' pieces</span><span class="tk-strip__pct">' + t.pct + '% off</span><span class="tk-strip__each">' + money(after(v.p, t.pct)) + ' each</span></li>';
      }).join('') + '</ol>';
    }
    var pct = 0, how = 'Applied automatically in your bag';
    if (MAIN.kind === 'collection') { if (!(d.cols || '').length) return ''; pct = MAIN.pct; }
    else if (MAIN.kind === 'code') {
      pct = MAIN.pct;
      how = cookieCode() === String(MAIN.code).toUpperCase() ? 'Your code ' + MAIN.code + ' is applied' : 'With code ' + MAIN.code + ' at checkout';
    } else if (MAIN.kind === 'sitewide') pct = MAIN.pct;
    else return '';
    var fin = after(v.p, pct);
    if (marked) {
      var tot = Math.round((1 - fin / v.c) * 1000) / 10;
      return '<div class="tk-pdp__price"><s>' + money(v.c) + '</s> <strong>' + money(fin) + '</strong><span class="tk-pdp__save">' + Math.floor(tot) + '% off</span></div>' +
        '<p class="tk-pdp__how">Sale price ' + money(v.p) + ', plus an extra ' + pct + '%. ' + esc(how) + '.</p>';
    }
    return '<div class="tk-pdp__price"><s>' + money(v.p) + '</s> <strong>' + money(fin) + '</strong><span class="tk-pdp__save">Save ' + pct + '%</span></div>' +
      '<p class="tk-pdp__how">' + esc(how) + '.</p>';
  }
  var CARRIER_HOLIDAYS = ['2026-11-26', '2026-12-25', '2027-01-01'];
  // Shipping cutoffs are Central time, whatever the shopper's clock says.
  function central(t) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23', weekday: 'short' })
      .formatToParts(new Date(t)).forEach(function (p) { parts[p.type] = p.value; });
    return { y: +parts.year, m: +parts.month - 1, d: +parts.day, h: +parts.hour, min: +parts.minute,
             dow: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(parts.weekday) };
  }
  function addBusinessDays(y, m, d, n) { // calendar arithmetic on a plain date, no time zone involved
    var x = new Date(Date.UTC(y, m, d));
    while (n > 0) {
      x.setUTCDate(x.getUTCDate() + 1);
      var w = x.getUTCDay(), iso = x.toISOString().slice(0, 10);
      if (w !== 0 && w !== 6 && CARRIER_HOLIDAYS.indexOf(iso) < 0) n--;
    }
    return x;
  }
  function shortDay(x) { return DAYS[x.getUTCDay()].slice(0, 3) + ', ' + MONTHS[x.getUTCMonth()].slice(0, 3) + ' ' + x.getUTCDate(); }
  function pdpDelivery(d) {
    var rows = [], t = now();
    var ch = parseInt(C.cutoffHour, 10), gd = String(C.groundDays || '').split('-').map(function (x) { return parseInt(x, 10); });
    if (!isNaN(ch) && !isNaN(gd[0])) {
      var c = central(t);
      var todayIso = new Date(Date.UTC(c.y, c.m, c.d)).toISOString().slice(0, 10);
      var weekday = c.dow !== 0 && c.dow !== 6 && CARRIER_HOLIDAYS.indexOf(todayIso) < 0;
      var shipsToday = weekday && c.h < ch;
      var minsLeft = (ch - c.h) * 60 - c.min;
      var base = shipsToday ? new Date(Date.UTC(c.y, c.m, c.d)) : addBusinessDays(c.y, c.m, c.d, 1);
      var a = addBusinessDays(base.getUTCFullYear(), base.getUTCMonth(), base.getUTCDate(), gd[0]);
      var b = gd[1] ? addBusinessDays(base.getUTCFullYear(), base.getUTCMonth(), base.getUTCDate(), gd[1]) : null;
      rows.push('<li><strong>Arrives ' + shortDay(a) + (b ? ' to ' + shortDay(b) : '') + '</strong>' + (shipsToday ? ' if you order within ' + countdown(minsLeft * 60000) : '') + '</li>');
    }
    var ship = STATE.ship;
    rows.push('<li>' + (ship ? 'Free 2-day shipping on orders of ' + money(ship.threshold) + ' or more, through ' + longDate(ship.end) : 'Free U.S. shipping on orders of ' + money(C.freeShip) + ' or more') + '</li>');
    var dl = C.deadlines || {};
    var custom = d.custom === 'true';
    var dd = [];
    if (custom && dl.custom) dd.push('embroidered pieces by ' + dl.custom);
    if (dl.ground) dd.push('ground by ' + dl.ground);
    if (dl.express) dd.push('express by ' + dl.express);
    if (dd.length) rows.push('<li>For delivery before the holidays, order ' + dd.join(', ') + '.</li>');
    return '<ul class="tk-delivery">' + rows.join('') + '</ul>';
  }

  /* ---------- bag drawer ---------- */
  function renderBag() {
    var c = document.querySelector('[data-tk-bag-count]');
    if (c && BAG) { c.textContent = BAG.item_count; c.hidden = !BAG.item_count; c.parentNode.setAttribute('aria-label', 'Bag, ' + BAG.item_count + ' items'); }
    document.querySelectorAll('[data-tk-bag]').forEach(renderBagInto);
  }
  function renderBagInto(el) {
    if (!BAG || !BAG.item_count) { el.innerHTML = ''; el.hidden = true; return; }
    var out = '', n = bagElig(BAG);
    if (MAIN && MAIN.kind === 'tiers') {
      var cur = tierFor(n), nx = nextTier(n);
      out += '<div class="tk-bag__row"><span>' + (cur ? '<strong>' + cur.pct + '% off</strong> ' + n + ' eligible pieces' : n + (n === 1 ? ' eligible piece' : ' eligible pieces')) + '</span>' +
        (nx ? '<span class="tk-bag__hint">Add ' + (nx.qty - n) + ' more for ' + nx.pct + '%</span>' : '<span class="tk-bag__hint">Best price reached</span>') + '</div>' +
        '<span class="tk-meter tk-meter--bag" aria-hidden="true"><i style="width:' + Math.min(100, n / TIERS[TIERS.length - 1].qty * 100) + '%"></i></span>';
    } else if (MAIN && (MAIN.kind === 'sitewide' || MAIN.kind === 'collection' || MAIN.kind === 'code')) {
      var pct = MAIN.pct, est = 0, applied = 0;
      BAG.items.forEach(function (i) {
        var ok = MAIN.kind === 'collection' ? i.handles.some(function (h) { return MAIN.handles.indexOf(h) > -1; }) : i.elig;
        if (!ok) return; // bundles, Presidents Cup and gift cards are reported on their own
        if (i.line_discount > 0) { applied += i.line_discount; return; }
        est += Math.round(i.final_line * pct / 100);
      });
      var codeOk = MAIN.kind !== 'code' || cookieCode() === String(MAIN.code).toUpperCase() || BAG.codes.indexOf(MAIN.code) > -1;
      if (applied > 0) out += '<div class="tk-bag__row tk-bag__row--saved"><span>Holiday savings applied</span><strong>\u2212' + money(applied) + '</strong></div>';
      if (est > 0) {
        out += '<div class="tk-bag__row tk-bag__row--est"><span>' + (MAIN.kind === 'code' && !codeOk ? 'With code ' + esc(MAIN.code) + ' you save' : 'Your ' + pct + '% off, applied at checkout') + '</span><strong>\u2212' + money(est) + '</strong></div>';
      }
      if (!applied && !est) out += '<div class="tk-bag__row"><span>Items in your bag are not part of the current offer.</span></div>';
    }
    var bsave = BAG.items.reduce(function (a, i) { return a + (i.bundle ? i.line_discount : 0); }, 0);
    if (bsave > 0) out += '<div class="tk-bag__row tk-bag__row--saved"><span>Bundle savings applied</span><strong>\u2212' + money(bsave) + '</strong></div>';
    else if (BAG.items.some(function (i) { return i.bundle; })) out += '<div class="tk-bag__row tk-bag__row--small"><span>Bundles are ' + C.bundle.pct + '% off, applied automatically.</span></div>';
    var gap = (STATE.ship ? STATE.ship.threshold : C.freeShip) - BAG.total_price;
    out += '<div class="tk-bag__row tk-bag__row--small"><span>' + (gap > 0 ? money(gap) + ' from free ' + (STATE.ship ? '2-day' : 'U.S.') + ' shipping' : 'Free ' + (STATE.ship ? '2-day' : 'U.S.') + ' shipping unlocked') + '</span></div>';
    el.innerHTML = out;
    el.hidden = false;
  }

  /* ---------- header, drawer, search ---------- */
  function lockScroll(on) { document.documentElement.classList.toggle('tk-locked', !!on); }
  function openDrawer() {
    var d = document.querySelector('[data-tk-drawer]'); if (!d) return;
    renderDrawerExtras();
    d.hidden = false; lockScroll(true);
    var b = document.querySelector('[data-tk-drawer-open]'); if (b) b.setAttribute('aria-expanded', 'true');
    var f = d.querySelector('summary, a, button'); if (f) f.focus();
  }
  function closeDrawer() {
    var d = document.querySelector('[data-tk-drawer]'); if (!d || d.hidden) return;
    d.hidden = true; lockScroll(false);
    var b = document.querySelector('[data-tk-drawer-open]'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
  }
  function renderDrawerExtras() {
    var o = document.querySelector('[data-tk-drawer-offer]');
    if (o) {
      var L = offerLabel(), left = MAIN ? MAIN.e - now() : 0;
      o.innerHTML = '<a href="' + esc(L.url) + '" class="tk-drawer__offercard"><strong>' + esc(L.title) + '</strong><span>' + esc(L.note) +
        (MAIN && left > 0 && left < 7 * 864e5 ? ' · ends in ' + countdown(left) : '') + '</span></a>';
    }
    var r = document.querySelector('[data-tk-recent]'), list = document.querySelector('[data-tk-recent-list]');
    if (r && list) {
      var items = recent().filter(function (x) { return x.handle !== (PEX && PEX.dataset.handle); }).slice(0, 4);
      list.innerHTML = items.map(function (x) {
        return '<li><a class="tk-mini__item" href="' + esc(x.url) + '">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="64" height="80" loading="lazy">' : '') + '<span>' + esc(x.title) + '</span></a></li>';
      }).join('');
      r.hidden = !items.length;
    }
  }
  function recent() { try { return JSON.parse(localStorage.getItem('tk-recent') || '[]'); } catch (e) { return []; } }
  function saveRecent() {
    var el = document.querySelector('[data-tk-recent-item]'); if (!el) return;
    try {
      var it = JSON.parse(el.textContent), list = recent().filter(function (x) { return x.handle !== it.handle; });
      list.unshift(it); localStorage.setItem('tk-recent', JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }
  var SYN = String(C.synonyms || '').split(',').map(function (p) { var a = p.split('='); return [String(a[0] || '').trim().toLowerCase(), String(a[1] || '').trim()]; })
    .filter(function (p) { return p[0] && p[1]; }).sort(function (a, b) { return b[0].length - a[0].length; });
  function rewrite(q) {
    var s = ' ' + String(q || '').toLowerCase() + ' ';
    SYN.forEach(function (p) { s = s.split(' ' + p[0] + ' ').join(' ' + p[1].toLowerCase() + ' '); });
    return s.trim();
  }
  /* ---------- search overlay and predictive search ---------- */
  var S_CACHE = {}, sCtl = null, sugTimer, sugSeq = 0, sActive = -1;
  function sEls() {
    var root = document.querySelector('[data-tk-search]');
    return root ? { root: root, input: root.querySelector('[data-tk-search-input]'), zero: root.querySelector('[data-tk-search-zero]'),
      live: root.querySelector('[data-tk-search-results]'), clear: root.querySelector('[data-tk-search-clear]') } : null;
  }
  function recentQs() { try { return JSON.parse(localStorage.getItem('tk-recent-q') || '[]'); } catch (e) { return []; } }
  function saveQ(q) {
    q = String(q || '').trim(); if (q.length < 2) return;
    try { var l = recentQs().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); l.unshift(q); localStorage.setItem('tk-recent-q', JSON.stringify(l.slice(0, 6))); } catch (e) {}
  }
  function searchUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
  function renderRecent() {
    var wrap = document.querySelector('[data-tk-search-recent]'), list = document.querySelector('[data-tk-search-recent-list]');
    if (!wrap || !list) return;
    var qs = recentQs();
    list.innerHTML = qs.map(function (q) { return '<li><a class="tk-chip tk-chip--recent" data-tk-opt data-tk-q="' + esc(q) + '" href="' + searchUrl(q) + '">' + esc(q) + '</a></li>'; }).join('');
    wrap.hidden = !qs.length;
  }
  function openSearch() {
    var E = sEls(); if (!E) return;
    renderRecent();
    E.root.hidden = false; lockScroll(true);
    var b = document.querySelector('[data-tk-search-open]'); if (b) b.setAttribute('aria-expanded', 'true');
    setTimeout(function () { E.input.focus(); E.input.select(); }, 30);
  }
  function closeSearch() {
    var E = sEls(); if (!E || E.root.hidden) return;
    E.root.hidden = true; lockScroll(false); setActive(-1);
    var b = document.querySelector('[data-tk-search-open]'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
  }
  function hl(text, q) {
    var t = esc(text), words = String(q || '').toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
    words.forEach(function (w) { t = t.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); });
    return t;
  }
  // Corporate pieces live only on their own (locked) pages: never in rows, search or recommendations.
  function isCorporate(tags) {
    if (typeof tags === 'string') tags = tags.split(',');
    return (tags || []).some(function (t) { return String(t).trim().toLowerCase() === 'corporate'; });
  }
  function eligibleTags(tags) {
    var ex = String(C.excluded || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    return !(tags || []).some(function (t) { return ex.indexOf(String(t).toLowerCase()) > -1; });
  }
  // Search card price. Predictive search gives the lowest price across variants and the highest compare-at
  // price across variants, which can come from different variants (a sale color next to a full-price one),
  // so pairing them showed a price the product page never shows. Products with a price range now read
  // "From [lowest]" (as collection cards do), and a crossed-out price only shows when every variant costs the same.
  function sCents(x) { var v = parseFloat(x); return isNaN(v) ? 0 : Math.round(v * 100); }
  function sProduct(p, q) {
    var pmin = sCents(p.price_min != null ? p.price_min : p.price), pmax = sCents(p.price_max != null ? p.price_max : p.price);
    if (pmax < pmin) pmax = pmin;
    var cmax = sCents(p.compare_at_price_max), price = pmin;
    var priceHtml = pmax > pmin ? '<span class="tk-sprod__from">From</span> ' + money(pmin) : (cmax > pmin ? '<s>' + money(cmax) + '</s> ' : '') + money(pmin);
    var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var line = '', pct = MAIN && (MAIN.kind === 'sitewide' || MAIN.kind === 'code') ? MAIN.pct : 0;
    var tags = p.tags || [];
    if (tags.indexOf(C.pc && 'Presidents-Cup-2026') > -1 && pcLive()) line = C.pc.pct + '% off with code ' + C.pc.code;
    else if (tags.indexOf('bundle') > -1) line = money(after(price, C.bundle.pct)) + ' with bundle savings';
    else if (pct && eligibleTags(tags)) line = (pmax > pmin ? 'From ' : '') + money(after(price, pct)) + (MAIN.kind === 'code' ? ' with code ' + MAIN.code : ' in your bag');
    return '<li><a class="tk-sprod" data-tk-opt href="' + esc(p.url) + '">' +
      '<span class="tk-sprod__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="400" height="500" loading="lazy">' : '') + (p.available === false ? '<span class="tk-sprod__badge">Sold out</span>' : '') + '</span>' +
      '<span class="tk-sprod__title">' + hl(String(p.title).split('|')[0].trim(), q) + '</span>' +
      '<span class="tk-sprod__price">' + priceHtml + '</span>' +
      (line ? '<span class="tk-sprod__offer">' + esc(line) + '</span>' : '') + '</a></li>';
  }
  function renderSuggest(d, q, raw) {
    var E = sEls(); if (!E) return;
    var R = (d && d.resources && d.resources.results) || {};
    var qs = (R.queries || []).filter(function (x) { return x.text && x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 5);
    var cols = (R.collections || []).filter(function (c) { return !/corporate|marsh|lincoln|volunteer|pga-tour-corp|proper-golf|employee/i.test(c.handle); }).slice(0, 5);
    var prods = (R.products || []).filter(function (p) { return !isCorporate(p.tags); }).slice(0, 4);
    var note = raw.trim().toLowerCase() !== q ? '<p class="tk-search__note">Showing results for <strong>' + esc(q) + '</strong></p>' : '';
    if (!prods.length && !cols.length && !qs.length) {
      E.live.innerHTML = note + '<div class="tk-search__none"><p class="tk-search__noneh">Nothing matched \u201c' + esc(raw) + '\u201d</p><p>Check the spelling, or try one of the popular searches.</p></div>';
      E.zero.hidden = false; E.live.hidden = false; return;
    }
    E.live.innerHTML = note + '<div class="tk-search__cols"><div class="tk-search__col">' +
      (qs.length ? '<p class="tk-search__h">Suggestions</p><ul class="tk-search__links">' + qs.map(function (x) { return '<li><a data-tk-opt data-tk-q="' + esc(x.text) + '" href="' + searchUrl(x.text) + '">' + hl(x.text, q) + '</a></li>'; }).join('') + '</ul>' : '') +
      (cols.length ? '<p class="tk-search__h">Categories</p><ul class="tk-search__links">' + cols.map(function (c) { return '<li><a data-tk-opt href="' + esc(c.url) + '">' + hl(String(c.title).replace(/<[^>]+>/g, ''), q) + '</a></li>'; }).join('') + '</ul>' : '') +
      '</div><div class="tk-search__col tk-search__col--wide">' +
      (prods.length ? '<p class="tk-search__h">Products</p><ul class="tk-search__grid">' + prods.map(function (p) { return sProduct(p, q); }).join('') + '</ul>' : '') +
      '</div></div><a class="tk-search__all" data-tk-opt data-tk-q="' + esc(q) + '" href="' + searchUrl(q) + '">See all results for \u201c' + esc(raw.trim()) + '\u201d<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" fill="none"/></svg></a>';
    E.zero.hidden = true; E.live.hidden = false;
  }
  function suggest(raw) {
    var E = sEls(); if (!E) return;
    var q = rewrite(raw);
    E.clear.hidden = !raw; setActive(-1);
    E.input.setAttribute('aria-expanded', q.length >= 2 ? 'true' : 'false');
    if (q.length < 2) { E.live.hidden = true; E.live.innerHTML = ''; E.zero.hidden = false; E.root.classList.remove('is-loading'); return; }
    if (S_CACHE[q]) { renderSuggest(S_CACHE[q], q, raw); return; }
    var seq = ++sugSeq;
    if (sCtl && sCtl.abort) sCtl.abort();
    sCtl = window.AbortController ? new AbortController() : null;
    E.root.classList.add('is-loading');
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor',
      sCtl ? { signal: sCtl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (d) { S_CACHE[q] = d; if (seq === sugSeq) renderSuggest(d, q, raw); })
      .catch(function () {})
      .then(function () { if (seq === sugSeq) E.root.classList.remove('is-loading'); });
  }
  function opts() { var E = sEls(); return E ? Array.prototype.filter.call(E.root.querySelectorAll('[data-tk-opt]'), function (a) { return a.offsetParent !== null; }) : []; }
  function setActive(i) {
    var E = sEls(); if (!E) return;
    var o = opts();
    o.forEach(function (a, j) { a.classList.toggle('is-active', j === i); a.id = a.id || ('tk-opt-' + j); });
    sActive = i;
    if (i > -1 && o[i]) { E.input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' }); }
    else E.input.removeAttribute('aria-activedescendant');
  }
  document.addEventListener('keydown', function (e) {
    var E = sEls(); if (!E || E.root.hidden) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var o = opts(); if (!o.length) return;
      e.preventDefault();
      var n = sActive + (e.key === 'ArrowDown' ? 1 : -1);
      if (n < -1) n = o.length - 1; if (n >= o.length) n = -1;
      setActive(n);
    } else if (e.key === 'Enter' && sActive > -1 && document.activeElement === E.input) {
      var a = opts()[sActive]; if (a) { e.preventDefault(); if (a.getAttribute('data-tk-q')) saveQ(a.getAttribute('data-tk-q')); location.href = a.href; }
    }
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-tk-search] [data-tk-q]');
    if (a) saveQ(a.getAttribute('data-tk-q'));
    var c = e.target.closest && e.target.closest('[data-tk-search-clear]');
    if (c) { var E = sEls(); E.input.value = ''; suggest(''); E.input.focus(); }
  });
  function openBag(e) {
    if (bagOpen()) { if (e) e.preventDefault(); return; }
    var d = document.querySelector('store-cart-drawer, cart-drawer');
    if (d && typeof d.open === 'function') { if (e) e.preventDefault(); d.open(); }
  }


  /* ---------- active tab ---------- */
  function markActiveTab() {
    var src = document.querySelector('[data-tk-active-tab]'); var name = src ? src.getAttribute('data-tk-active-tab') : '';
    if (!name) return;
    document.querySelectorAll('[data-tk-tab]').forEach(function (a) {
      var on = a.getAttribute('data-tk-tab') === name;
      a.classList.toggle('is-active', on);
    });
  }

  /* ---------- chips: swap the collection in place ---------- */
  var swapping = false;
  function carryParams(href) {
    var cur = new URLSearchParams(location.search), u = new URL(href, location.origin);
    cur.forEach(function (v, k) { if ((k === 'sort_by' || k.indexOf('filter.') === 0) && !u.searchParams.has(k)) u.searchParams.append(k, v); });
    return u.pathname + u.search;
  }
  function swapTo(url, push) {
    if (swapping) return; swapping = true;
    var main = document.getElementById('MainContent'), head = document.querySelector('[data-tk-colhead]');
    if (main) main.classList.add('tk-swapping');
    fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var nm = doc.getElementById('MainContent'), nh = doc.querySelector('[data-tk-colhead]');
      if (!nm || !main) throw 0;
      main.innerHTML = nm.innerHTML;
      if (head && nh) head.replaceWith(nh); else if (nh && main.parentNode) main.parentNode.insertBefore(nh, main);
      document.title = doc.title;
      if (push) history.pushState({ tk: 1 }, '', url);
      markActiveTab(); renderCards(); renderPdp(); initRows(document);
      var top = (document.querySelector('[data-tk-colhead]') || main).getBoundingClientRect().top + window.scrollY - 8;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }).catch(function () { location.href = url; }).then(function () { swapping = false; if (main) main.classList.remove('tk-swapping'); });
  }
  window.addEventListener('popstate', function () { if (html.classList.contains('tk-col') || html.classList.contains('tk-srch')) swapTo(location.pathname + location.search, false); });

  /* ---------- product rows (Section Rendering API) ---------- */
  function initRows(root) {
    (root || document).querySelectorAll('[data-tk-row][data-src]:not(.is-ready):not(.is-loading)').forEach(loadRow);
  }
  function loadRow(row) {
    var src = row.getAttribute('data-src'), sec = row.getAttribute('data-section') || 'tk-row';
    row.classList.add('is-loading');
    var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sec;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html'), track = doc.querySelector('.tk-row__track');
      var ex = row.getAttribute('data-exclude');
      if (track && ex) track.querySelectorAll('[data-handle="' + ex + '"]').forEach(function (n) { n.remove(); });
      row.innerHTML = '';
      if (track && track.children.length) {
        row.appendChild(track);
        row.insertAdjacentHTML('beforeend', '<button type="button" class="tk-row__nav tk-row__nav--prev" data-tk-row-nav="-1" aria-label="Previous"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button><button type="button" class="tk-row__nav tk-row__nav--next" data-tk-row-nav="1" aria-label="Next"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button>');
        row.classList.add('has-items');
      } else row.classList.add('is-empty');
      row.classList.remove('is-loading'); row.classList.add('is-ready');
      renderCards(row);
      row.dispatchEvent(new CustomEvent('tk:row', { bubbles: true }));
    }).catch(function () { row.classList.remove('is-loading'); row.classList.add('is-ready', 'is-empty'); });
  }

  /* ---------- product page: tabs, breadcrumbs, sticky Add to bag ---------- */
  var PEX = null;
  function initProductExtras() {
    PEX = document.querySelector('[data-tk-pextras]');
    if (!PEX || C.pass) return;
    var main = document.getElementById('MainContent');
    var buy = main && Array.prototype.filter.call(main.querySelectorAll(':scope > .shopify-section'), function (s) { return s.querySelector('form[action*="/cart/add"], product-info-content, .pinfo-top'); })[0];
    if (buy && buy.nextSibling) buy.parentNode.insertBefore(PEX, buy.nextSibling); else if (buy) buy.parentNode.appendChild(PEX);
    var crumbs = PEX.querySelector('[data-tk-pdp-crumbs]'), info = document.querySelector('product-info-content') || document.querySelector('.pinfo-top-wrap');
    if (crumbs && info) info.insertBefore(crumbs, info.firstChild);
    PEX.hidden = false;
    var tabs = PEX.querySelectorAll('[data-tk-ptab]');
    var userPicked = false;
    function select(name) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tk-ptab') === name ? 'true' : 'false'); });
      PEX.querySelectorAll('[data-tk-ppanel]').forEach(function (p) { p.hidden = p.getAttribute('data-tk-ppanel') !== name; });
    }
    function refresh() {
      var first = null;
      tabs.forEach(function (t) {
        var name = t.getAttribute('data-tk-ptab'), p = PEX.querySelector('[data-tk-ppanel="' + name + '"]');
        var has = p && p.querySelector('.tk-row__item');
        t.hidden = !has; if (has && !first) first = name;
      });
      var cur = PEX.querySelector('[data-tk-ptab][aria-selected="true"]:not([hidden])');
      if ((!cur || !userPicked) && first) select(first);
      PEX.querySelector('.tk-ptabs').hidden = !first;
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { userPicked = true; select(t.getAttribute('data-tk-ptab')); }); });
    PEX.addEventListener('tk:row', refresh);
    refresh();
    initRows(PEX);
    initSticky();
  }
  function realAtc() {
    var c = document.querySelectorAll('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
    for (var i = 0; i < c.length; i++) { var b = c[i]; if (b.offsetParent !== null && !b.closest('[data-tk-satb], .tk-row, [data-tk-pextras]')) return b; }
    return null;
  }
  function otherStickyAtc() {
    var n = document.querySelectorAll('[class*="sticky"][class*="atc"], [class*="sticky"][class*="add-to-cart"], [class*="sticky-cart"], sticky-atc');
    for (var i = 0; i < n.length; i++) { var cs = getComputedStyle(n[i]); if (cs.position === 'fixed' && cs.display !== 'none' && n[i].offsetHeight > 0) return true; }
    return false;
  }
  function initSticky() {
    var bar = document.querySelector('[data-tk-satb]'), btn = document.querySelector('[data-tk-satb-btn]');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var target = null, io = null, past = false;
    function price() {
      var el = document.querySelector('[data-tk-satb-price]'), id = currentVariantId();
      var v = (PDP.variants || []).filter(function (x) { return x.id === id; })[0];
      if (el && v) el.textContent = money(v.p);
    }
    function watch() {
      var b = realAtc(); if (b === target) return;
      if (io) io.disconnect();
      target = b; if (!b) return;
      io = new IntersectionObserver(function (en) {
        var e = en[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0;
        var show = past && !otherStickyAtc();
        bar.hidden = !show; bar.setAttribute('aria-hidden', show ? 'false' : 'true'); btn.tabIndex = show ? 0 : -1;
        html.classList.toggle('tk-satb-on', show);
      });
      io.observe(b);
    }
    btn.addEventListener('click', function () {
      var b = realAtc() || target;
      if (!b) return;
      if (b.disabled) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      b.click();
    });
    watch(); price();
    setInterval(function () { watch(); price(); }, 800); // re-find after variant changes swap the form
  }


  /* ---------- homepage: chips swap the grid in place ---------- */
  var homeSeq = 0;
  function homeChip(a) {
    var grid = document.querySelector('[data-tk-home-grid]'); if (!grid) return false;
    var seq = ++homeSeq, href = a.getAttribute('href');
    document.querySelectorAll('[data-tk-home-chip]').forEach(function (c) { var on = c === a; c.classList.toggle('is-active', on); if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current'); });
    var t = document.querySelector('[data-tk-home-title]'), n = document.querySelector('[data-tk-home-count]');
    if (t) t.textContent = a.getAttribute('data-title');
    if (n) n.textContent = a.getAttribute('data-count') + ' pieces';
    document.querySelectorAll('[data-tk-home-all]').forEach(function (l) { l.href = href; if (l.classList.contains('tk-btn')) l.textContent = 'Shop all ' + a.getAttribute('data-title'); });
    grid.classList.add('tk-swapping');
    fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=tk-grid', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (txt) {
        if (seq !== homeSeq) return;
        var doc = new DOMParser().parseFromString(txt, 'text/html'), g = doc.querySelector('.tk-grid');
        grid.innerHTML = ''; if (g) grid.appendChild(g);
        renderCards(grid);
      })
      .catch(function () { location.href = href; })
      .then(function () { grid.classList.remove('tk-swapping'); });
    return true;
  }

  /* ---------- bundle product page: "Your set", piece values, summary, remembered size ---------- */
  function visiblePanel() {
    var bs = document.querySelectorAll('[data-sb-bundle]');
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].offsetParent === null) continue; // desktop and mobile copies: use the one on screen
      var p = bs[i].querySelector('[data-sb-panel]:not([hidden])');
      if (p) return p;
    }
    return null;
  }
  function bigger(src) { return String(src || '').replace(/([?&])width=\d+/, '$1width=1000'); }
  function pieceColor(item) {
    var groups = item.querySelectorAll('[data-sb-group]');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].querySelector('.sb-swatch')) { var v = groups[i].querySelector('[data-sb-selected]'); return v ? v.textContent.trim() : ''; }
    }
    return '';
  }
  var setSig = '';
  function renderBundle() {
    if (!html.classList.contains('tk-bundle')) return;
    var panel = visiblePanel(); if (!panel) return;
    var items = panel.querySelectorAll('[data-sb-item]'); if (!items.length) return;
    var sum = 0, n = items.length;
    items.forEach(function (it, i) {
      var price = +it.getAttribute('data-tk-piece-price') || 0; sum += price;
      if (!it.querySelector('.tk-piece')) {
        var meta = it.querySelector('.sb-bundle__meta');
        if (meta) meta.insertAdjacentHTML('afterbegin', '<span class="tk-piece">Piece ' + (i + 1) + (price ? '<span class="tk-piece__val">' + money(price) + ' value</span>' : '') + '</span>');
      }
      it.id = it.id || ('tk-piece-' + (i + 1));
    });
    // Summary: separately, yours, saving. Bundles keep their own percentage all season.
    var pex = document.querySelector('[data-tk-pextras]');
    var bprice = pex ? +pex.getAttribute('data-bundle-price') : 0;
    var yours = after(bprice, C.bundle.pct), separately = Math.max(sum, bprice);
    var bundle = panel.closest('[data-sb-bundle]');
    var sumEl = bundle.querySelector('.tk-setsum');
    if (!sumEl) { bundle.insertAdjacentHTML('afterbegin', '<p class="tk-setsum"></p>'); sumEl = bundle.querySelector('.tk-setsum'); }
    sumEl.innerHTML = '<strong>' + n + ' pieces</strong><span>' + money(separately) + ' if bought separately</span><span class="tk-setsum__yours">yours for <strong>' + money(yours) + '</strong></span>' +
      (separately > yours ? '<span class="tk-setsum__save">Save ' + money(separately - yours) + '</span>' : '');
    // "Your set": replaces the gallery with the pieces in the chosen colors.
    var tiles = [], sig = '';
    items.forEach(function (it, i) {
      var img = it.querySelector('[data-sb-thumb]'), name = it.getAttribute('data-tk-piece-title') || '', color = pieceColor(it);
      var src = img ? bigger(img.currentSrc || img.src) : '';
      sig += src + color + '|';
      tiles.push('<button type="button" class="tk-set__tile" data-tk-jump="' + it.id + '">' + (src ? '<img src="' + esc(src) + '" alt="' + esc(name + (color ? ', ' + color : '')) + '" width="1000" height="1250" loading="' + (i ? 'lazy' : 'eager') + '">' : '') +
        '<span class="tk-set__label"><span class="tk-set__n">Piece ' + (i + 1) + '</span>' + esc(name) + (color ? '<em>' + esc(color) + '</em>' : '') + '</span></button>');
    });
    var media = Array.prototype.filter.call(document.querySelectorAll('product-info-media'), function (m) { return m.offsetParent !== null || m.querySelector('.tk-set'); })[0];
    if (!media) return;
    var set = media.querySelector('.tk-set');
    if (!set) { media.insertAdjacentHTML('afterbegin', '<div class="tk-set" aria-label="Your set"><p class="tk-set__head">Your set</p><div class="tk-set__grid"></div></div>'); set = media.querySelector('.tk-set'); }
    if (sig !== setSig) {
      setSig = sig;
      var grid = set.querySelector('.tk-set__grid');
      grid.className = 'tk-set__grid tk-set__grid--' + Math.min(n, 4);
      grid.innerHTML = tiles.join('');
    }
    html.classList.add('tk-set-on');
  }
  function rememberSize(btn) {
    var v = btn && btn.getAttribute('data-value'); if (!v) return;
    try { localStorage.setItem('tk-size', v); } catch (e) {}
  }
  function preselectSize() {
    var size; try { size = localStorage.getItem('tk-size'); } catch (e) {}
    var panel = visiblePanel(); if (!size || !panel) return;
    panel.querySelectorAll('[data-sb-group]').forEach(function (g) {
      var btns = g.querySelectorAll('.sb-size'); if (!btns.length) return;
      var pick = Array.prototype.filter.call(btns, function (b) { return String(b.getAttribute('data-value')).trim().toLowerCase() === size.trim().toLowerCase() && !b.disabled; })[0];
      if (pick && pick.getAttribute('aria-checked') !== 'true') pick.click();
    });
  }
  function initBundle() {
    if (!html.classList.contains('tk-bundle')) return;
    renderBundle(); preselectSize();
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.sb-swatch, .sb-size, [data-tk-jump]');
      if (!t) return;
      if (t.classList.contains('sb-size')) rememberSize(t);
      if (t.hasAttribute('data-tk-jump')) {
        var el = document.getElementById(t.getAttribute('data-tk-jump'));
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.classList.remove('tk-flash'); void el.offsetWidth; el.classList.add('tk-flash'); }
        return;
      }
      setTimeout(renderBundle, 80); setTimeout(renderBundle, 400); // thumbnails swap after the app's own handler
    });
    var root = document.querySelector('[data-sb-bundle]');
    if (root && 'MutationObserver' in window) new MutationObserver(function () { clearTimeout(initBundle.t); initBundle.t = setTimeout(renderBundle, 60); })
      .observe(root, { attributes: true, subtree: true, attributeFilter: ['hidden', 'src'] });
  }
  // Remember the last size chosen on any product page, for bundles.
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.name || !/size/i.test(t.name + ' ' + (t.closest('fieldset') ? t.closest('fieldset').textContent.slice(0, 20) : ''))) return;
    try { localStorage.setItem('tk-size', t.value); } catch (er) {}
  });

  function niceVariant(t) {
    return String(t || '').split('/').map(function (p) {
      p = p.trim();
      if (p.length <= 4 || p !== p.toUpperCase()) return p; // sizes (SML, XL) and already-cased text stay as they are
      return p.toLowerCase().replace(/\b([a-z])/g, function (m) { return m.toUpperCase(); });
    }).join(' / ');
  }
  /* ---------- takeover bag (replaces the live drawer on takeover pages) ---------- */
  var BAGM = { el: null, open: false, recsFor: null, busy: false };
  function bagEl(sel) { return BAGM.el ? BAGM.el.querySelector(sel) : null; }
  function offerScope(i) {
    if (!MAIN || i.service) return false;
    if (MAIN.kind === 'collection') return i.handles.some(function (h) { return MAIN.handles.indexOf(h) > -1; });
    if (MAIN.kind === 'sitewide' || MAIN.kind === 'code') return i.elig;
    return false;
  }
  function bagOpen() {
    BAGM.el = document.querySelector('[data-tk-bagmodal]');
    if (!BAGM.el) return false;
    closeDrawer(); closeSearch();
    BAGM.el.hidden = false; BAGM.open = true; BAGM.redoAsked = false; lockScroll(true);
    BAGM.el.classList.add('is-loading');
    loadBag().then(function () { BAGM.el.classList.remove('is-loading'); var c = bagEl('[data-tk-bag-close]'); if (c) c.focus(); });
    return true;
  }
  function bagClose() {
    if (!BAGM.el || BAGM.el.hidden) return;
    BAGM.el.hidden = true; BAGM.open = false; lockScroll(false);
  }
  function renderBagModal() {
    if (!BAGM.el || !BAG) return;
    var items = BAG.items || [], n = BAG.item_count || 0;
    var nEl = bagEl('[data-tk-bag-n]'); if (nEl) nEl.textContent = n ? '(' + n + ')' : '';
    var empty = !items.length;
    BAGM.el.classList.toggle('is-empty', empty);
    bagEl('[data-tk-bag-empty]').hidden = !empty;
    // shipping progress
    var th = STATE.ship ? STATE.ship.threshold : C.freeShip, gap = th - BAG.total_price, what = STATE.ship ? 'free 2-day shipping' : 'free U.S. shipping';
    bagEl('[data-tk-bag-ship]').innerHTML = empty ? '' : '<span>' + (gap > 0 ? 'You are <strong>' + money(gap) + '</strong> from ' + what : 'You have <strong>' + what + '</strong>') + '</span><span class="tk-meter tk-meter--bag" aria-hidden="true"><i style="width:' + Math.min(100, th ? BAG.total_price / th * 100 : 0) + '%"></i></span>';
    // items
    var pct = MAIN && MAIN.pct ? MAIN.pct : 0, est = 0, lineSaved = 0;
    bagEl('[data-tk-bag-items]').innerHTML = items.map(function (i) {
      var scope = offerScope(i), estLine = scope && !i.line_discount ? Math.round(i.final_line * pct / 100) : 0;
      est += estLine; lineSaved += i.line_discount || 0;
      var orig = i.compare > i.price ? i.compare * i.qty : i.line;
      var now2 = i.final_line - estLine;
      var tag = i.line_discount ? (i.bundle ? 'Bundle savings' : i.pc ? 'Presidents Cup offer' : 'Offer applied') : estLine ? pct + '% off at checkout' : (i.compare > i.price ? 'Sale' : '');
      var props = (i.props || []).map(function (p) { return '<span>' + esc(p.k) + ': ' + esc(p.v) + '</span>'; }).join('');
      if (i.service) {
        return '<li class="tk-bitem tk-bitem--service"><span class="tk-bitem__svc">' + esc(i.title) + '</span><span class="tk-bitem__price"><strong>' + money(i.final_line) + '</strong></span><button type="button" class="tk-bitem__remove" data-tk-qty="0" data-key="' + esc(i.key) + '">Remove</button></li>';
      }
      return '<li class="tk-bitem" data-key="' + esc(i.key) + '">' +
        '<a class="tk-bitem__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" width="120" height="150" loading="lazy">' : '') + '</a>' +
        '<div class="tk-bitem__info"><a class="tk-bitem__title" href="' + esc(i.url) + '">' + esc(String(i.title).split('|')[0].trim()) + '</a>' +
        (i.variant_title && i.variant_title !== 'Default Title' ? '<span class="tk-bitem__var">' + esc(niceVariant(i.variant_title)) + '</span>' : '') +
        (props ? '<span class="tk-bitem__props">' + props + '</span>' : '') +
        '<div class="tk-bitem__row"><div class="tk-qty" role="group" aria-label="Quantity"><button type="button" data-tk-qty="' + (i.qty - 1) + '" data-key="' + esc(i.key) + '" aria-label="Decrease">\u2212</button><span aria-live="polite">' + i.qty + '</span><button type="button" data-tk-qty="' + (i.qty + 1) + '" data-key="' + esc(i.key) + '" aria-label="Increase"' + (i.qty >= i.available_qty_max ? ' disabled' : '') + '>+</button></div>' +
        '<button type="button" class="tk-bitem__remove" data-tk-qty="0" data-key="' + esc(i.key) + '">Remove</button></div></div>' +
        '<div class="tk-bitem__price">' + (now2 < orig ? '<s>' + money(orig) + '</s>' : '') + '<strong>' + money(now2) + '</strong>' + (tag ? '<span class="tk-bitem__tag">' + tag + '</span>' : '') + '</div></li>';
    }).join('');
    // offers (tier progress, applied and estimated savings)
    var offers = bagEl('[data-tk-bag-offers]'); renderBagInto(offers);
    // The totals already list every saving; the offer box only carries what totals can't (tier progress, codes).
    offers.querySelectorAll('.tk-bag__row--small, .tk-bag__row--saved, .tk-bag__row--est').forEach(function (r) { r.remove(); });
    offers.hidden = !offers.children.length;
    // totals
    var cartLevel = (BAG.cart_level_discounts || []).reduce(function (a, d) { return a + d.a; }, 0);
    var total = BAG.total_price - est;
    var rows = '<div><dt>Subtotal</dt><dd>' + money(BAG.original_total_price + items.reduce(function (a, i) { return a + (i.compare > i.price ? (i.compare - i.price) * i.qty : 0); }, 0)) + '</dd></div>';
    var arch = items.reduce(function (a, i) { return a + (i.compare > i.price ? (i.compare - i.price) * i.qty : 0); }, 0);
    if (arch) rows += '<div class="is-save"><dt>Sale pricing</dt><dd>\u2212' + money(arch) + '</dd></div>';
    if (lineSaved) rows += '<div class="is-save"><dt>Offers applied</dt><dd>\u2212' + money(lineSaved) + '</dd></div>';
    (BAG.cart_level_discounts || []).forEach(function (d) { rows += '<div class="is-save"><dt>' + esc(d.t) + '</dt><dd>\u2212' + money(d.a) + '</dd></div>'; });
    if (est) rows += '<div class="is-save is-est"><dt>' + pct + '% off, applied at checkout</dt><dd>\u2212' + money(est) + '</dd></div>';
    rows += '<div><dt>Shipping</dt><dd>' + (gap <= 0 ? 'Free' : 'Calculated at checkout') + '</dd></div>';
    rows += '<div class="is-total"><dt>' + (est ? 'Estimated total' : 'Total') + '</dt><dd>' + money(total) + '</dd></div>';
    bagEl('[data-tk-bag-totals]').innerHTML = empty ? '' : rows;
    var t1 = bagEl('[data-tk-bag-total]'), t2 = bagEl('[data-tk-bag-total2]');
    if (t1) t1.textContent = empty ? '' : '\u00b7 ' + money(total); if (t2) t2.textContent = money(total);
    var del = bagEl('[data-tk-bag-delivery]'); if (del) del.innerHTML = empty ? '' : pdpDelivery({ custom: items.some(function (i) { return /embroider/i.test(JSON.stringify(i.props)); }) ? 'true' : 'false' });
    BAGM.el.querySelectorAll('[data-tk-bag-checkout] button, [data-tk-bag-submit]').forEach(function (b) { b.disabled = empty; });
    loadRecs();
    bagCheckoutGuard();
  }
  // Redo (Checkout+) hides every [name="checkout"] button and draws its own in its place. In this bag it
  // sometimes hides ours without drawing a replacement, leaving no way to check out. After each render, ask
  // Redo to redraw, then make sure one checkout button is visible: Redo's if it drew one, ours otherwise.
  // Opacity isn't inherited, so a faded-out wrapper leaves the button reporting opacity 1: walk up to the side.
  function bagShown(el) {
    var r = el.getBoundingClientRect(); if (r.width < 2 || r.height < 2) return false;
    if (getComputedStyle(el).visibility === 'hidden') return false;
    var side = bagEl('[data-tk-bag-side]');
    for (var n = el; n && n !== side; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (+cs.opacity === 0 || cs.display === 'none' || (cs.clipPath && cs.clipPath !== 'none')) return false;
    }
    return true;
  }
  function bagEnsureCheckout() {
    if (!BAGM.el || BAGM.el.hidden || BAGM.el.classList.contains('is-empty')) return;
    if (!window.matchMedia('(min-width: 900px)').matches) return; // phones check out from the sticky bar
    var side = bagEl('[data-tk-bag-side]'), form = bagEl('[data-tk-bag-checkout]'), btn = form && form.querySelector('button');
    if (!side || !btn) return;
    var theirs = Array.prototype.some.call(side.querySelectorAll('button, a, [role="button"]'), function (b) {
      return b !== btn && /check\s*-?out/i.test(b.textContent || '') && bagShown(b);
    });
    var forced = form.hasAttribute('data-tk-forced');
    if (theirs && forced) { form.style.setProperty('display', 'none', 'important'); form.removeAttribute('data-tk-forced'); return; }
    var bg = getComputedStyle(btn).backgroundColor, unpainted = bg === 'transparent' || /rgba\(.*,\s*0\)$/.test(bg) || bg === 'rgb(255, 255, 255)';
    if (theirs || (bagShown(btn) && !unpainted)) return;
    for (var n = btn; n && n !== side; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.display === 'none') n.style.setProperty('display', 'block', 'important');
      if (cs.visibility === 'hidden') n.style.setProperty('visibility', 'visible', 'important');
      if (+cs.opacity === 0) n.style.setProperty('opacity', '1', 'important');
      if (cs.clipPath && cs.clipPath !== 'none') n.style.setProperty('clip-path', 'none', 'important');
    }
    btn.hidden = false;
    // Redo's [name="checkout"] rule also collapses the button (max-width/max-height 0, overflow hidden,
    // padding 0), all !important. Inline !important outranks any stylesheet, so restate the box and look here.
    var paint = { 'display': 'block', 'visibility': 'visible', 'max-width': 'none', 'max-height': 'none', 'overflow': 'visible', 'padding': '0 20px', 'margin': '0',
      'background-color': '#004027', 'color': '#ffffff', 'border': '0', 'min-height': '54px', 'width': '100%', 'filter': 'none', 'transform': 'none', 'pointer-events': 'auto' };
    Object.keys(paint).forEach(function (k) { btn.style.setProperty(k, paint[k], 'important'); });
    form.setAttribute('data-tk-forced', '');
  }
  // Redo can hide the button whenever it likes, not just inside the guard's timers: re-check on any change in the side.
  function bagWatchSide() {
    var side = bagEl('[data-tk-bag-side]'); if (!side || BAGM.sideObs || !window.MutationObserver) return;
    BAGM.sideObs = new MutationObserver(function () { clearTimeout(BAGM.guardC); BAGM.guardC = setTimeout(bagEnsureCheckout, 150); });
    BAGM.sideObs.observe(side, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }
  function bagCheckoutGuard() {
    // Once per opening: a Redo redraw can change the cart, and every cart change re-renders this bag.
    if (window.redoStorefront && !BAGM.redoAsked) { BAGM.redoAsked = true; document.dispatchEvent(new CustomEvent('redo:render-cart', { bubbles: true })); }
    bagWatchSide();
    clearTimeout(BAGM.guardA); clearTimeout(BAGM.guardB);
    BAGM.guardA = setTimeout(bagEnsureCheckout, 1200);
    BAGM.guardB = setTimeout(bagEnsureCheckout, 3500);
  }
  document.addEventListener('redo:checkout-buttons-rendered', function () { setTimeout(bagEnsureCheckout, 50); });
  function loadRecs() {
    var box = bagEl('[data-tk-bag-recs]'); if (!box || !BAG) return;
    var first = (BAG.items || []).filter(function (i) { return !i.service; })[0];
    if (!first) { box.hidden = true; return; }
    if (BAGM.recsFor === first.product_id) { filterRecs(); return; }
    BAGM.recsFor = first.product_id;
    fetch('/recommendations/products.json?product_id=' + first.product_id + '&limit=8&intent=related').then(function (r) { return r.json(); }).then(function (d) {
      var ps = (d.products || []).filter(function (p) { return p.available && !isCorporate(p.tags); });
      box.innerHTML = '<p class="tk-bag__recsh">Pairs well with</p><ul class="tk-bag__reclist">' + ps.slice(0, 8).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
        return '<li data-pid="' + p.id + '"><a class="tk-sprod" href="' + esc(p.url) + '"><span class="tk-sprod__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="300" height="375" loading="lazy">' : '') + '</span><span class="tk-sprod__title">' + esc(String(p.title).split('|')[0].trim()) + '</span><span class="tk-sprod__price">' + money(p.price) + '</span></a></li>';
      }).join('') + '</ul>';
      filterRecs();
    }).catch(function () { box.hidden = true; });
  }
  function filterRecs() {
    var box = bagEl('[data-tk-bag-recs]'); if (!box) return;
    var inBag = (BAG.items || []).map(function (i) { return String(i.product_id); }), shown = 0;
    box.querySelectorAll('[data-pid]').forEach(function (li) { var hide = inBag.indexOf(li.getAttribute('data-pid')) > -1 || shown >= 4; li.hidden = hide; if (!hide) shown++; });
    box.hidden = !shown;
  }
  function changeQty(key, qty) {
    if (BAGM.busy) return; BAGM.busy = true;
    BAGM.el.classList.add('is-loading');
    _f.call(window, '/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function () { return loadBag(); })
      .then(function () { try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tk-bag' }); } catch (e) {} })
      .catch(function () {})
      .then(function () { BAGM.busy = false; BAGM.el.classList.remove('is-loading'); });
  }
  // The live drawer's open() (called after every add to bag) opens the takeover bag instead.
  function hijackLiveDrawer() {
    if (!html.classList.contains('tk-hdr') || !window.customElements) return;
    ['store-cart-drawer', 'cart-drawer'].forEach(function (name) {
      customElements.whenDefined(name).then(function () {
        var K = customElements.get(name); if (!K || K.prototype.__tk) return;
        var orig = K.prototype.open;
        K.prototype.open = function () { if (html.classList.contains('tk-hdr') && document.querySelector('[data-tk-bagmodal]')) { this.classList.remove('active'); bagOpen(); return; } return orig.apply(this, arguments); };
        K.prototype.__tk = true;
      });
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    if (t.closest('[data-tk-bag-close]')) { bagClose(); return; }
    var q = t.closest('[data-tk-qty]');
    if (q && BAGM.open) { changeQty(q.getAttribute('data-key'), +q.getAttribute('data-tk-qty')); return; }
    if (t.closest('[data-tk-bag-submit]')) { var f = bagEl('[data-tk-bag-checkout]'); if (f) { var b = f.querySelector('button'); if (b) b.click(); } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && BAGM.open) bagClose(); });

  /* ---------- filters and sorting (collections and search) ---------- */
  // One delegated controller, so Filter and Sort keep working after chips swap the grid in place
  // (the live theme binds its buttons once, at page load).
  function fPanel() { return document.querySelector('#main-collection-filters, #main-search-filters'); }
  function fCount() {
    var el = document.querySelector('#ProductCountDesktop, #ProductCount');
    var m = el && /([\d,]+)/.exec(el.textContent || '');
    return m ? +m[1].replace(/,/g, '') : null;
  }
  // Active filter count for the Filter button. The panel holds each filter value more than once (the theme renders
  // a desktop and a mobile copy of the same inputs), so counting checked boxes doubled the number: count each
  // name=value pair once, and any price range as one filter.
  function fActive() {
    var p = fPanel(); if (!p) return 0;
    var seen = {}, n = 0;
    p.querySelectorAll('input[type="checkbox"]:checked').forEach(function (i) {
      var k = (i.name || '') + '=' + (i.value || ''); if (!seen[k]) { seen[k] = 1; n++; }
    });
    var price = Array.prototype.some.call(p.querySelectorAll('input[type="number"][name*="price"]'), function (i) { return !!i.value; });
    return n + (price ? 1 : 0);
  }
  var F_OPEN = null; // labels of open filter groups, kept across re-renders
  function fSetOpen(g, on) {
    g.classList.toggle('active', on);
    var b = g.querySelector('.accordion-body, .facets__display-vertical'); if (b) b.style.maxHeight = on ? 'none' : '';
    var h = g.querySelector('.accordion-header, .facets__summary'); if (h) h.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function fDecorate() {
    var p = fPanel(); if (!p || C.pass) return;
    var first = F_OPEN === null; if (first) F_OPEN = {};
    var hide = String(C.filterHide || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var ren = {}; String(C.filterRename || '').split(',').forEach(function (pr) { var a = pr.split('='); if (a[0] && a[1]) ren[a[0].trim().toLowerCase()] = a[1].trim(); });
    p.querySelectorAll('.js-filter, .facets__disclosure-vertical, details').forEach(function (g) {
      var lab = g.querySelector('.facets__summary-label, summary h4, summary span');
      if (!lab) return;
      var raw = (lab.getAttribute('data-tk-raw') || lab.childNodes[0] && lab.childNodes[0].textContent || lab.textContent || '').trim();
      if (!lab.hasAttribute('data-tk-raw')) lab.setAttribute('data-tk-raw', raw);
      var key = raw.toLowerCase();
      if (hide.indexOf(key) > -1) { g.style.display = 'none'; return; }
      if (ren[key] && lab.childNodes[0] && lab.childNodes[0].nodeType === 3) lab.childNodes[0].textContent = ren[key] + ' ';
      var ul = g.querySelector('ul'); if (ul && /size/i.test(raw)) ul.classList.add('tk-fsizes');
      if (g.classList.contains('accordion-item')) {
        var vis = Array.prototype.indexOf.call(p.querySelectorAll('.accordion-item'), g);
        if (first && (vis < 2 || g.querySelector('input:checked'))) F_OPEN[key] = true;
        fSetOpen(g, !!F_OPEN[key]);
      }
    });
    // Footer: live count on the apply button, and the active count on the Filter button
    var n = fCount(), apply = p.querySelector('[hide-filter].hide__filter');
    if (apply) apply.textContent = n === null ? 'Show results' : 'Show ' + n + (n === 1 ? ' piece' : ' pieces');
    var a = fActive(), ftxt = a ? 'Filter (' + a + ')' : 'Filter';
    // Only write when the text changes, so this doesn't trigger the MutationObserver that calls fDecorate again
    document.querySelectorAll('[filter-opener] span').forEach(function (s) { if (s.textContent !== ftxt) s.textContent = ftxt; });
    var clear = p.querySelector('[clear-all-filter]'); if (clear) clear.disabled = !a;
    // Sort button shows the current sort
    var checked = document.querySelector('#FacetSortForm input[type="radio"]:checked, .sort-radio:checked');
    var lbl = checked && document.querySelector('label[for="' + checked.id + '"]');
    document.querySelectorAll('[sort-opener] span').forEach(function (s) { s.textContent = lbl ? 'Sort: ' + lbl.textContent.trim() : 'Sort'; });
    // Collection head count follows the filters
    var hc = document.querySelector('[data-tk-colhead] .tk-colhead__count');
    if (hc && n !== null && html.classList.contains('tk-col')) hc.textContent = n + (n === 1 ? ' piece' : ' pieces');
  }
  function fOpen(on) {
    var p = fPanel(); if (!p) return;
    p.classList.toggle('open', on);
    html.classList.toggle('tk-filters-open', on);
    lockScroll(on);
    document.querySelectorAll('[filter-opener]').forEach(function (b) { b.classList.toggle('active', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    if (on) { fDecorate(); var f = p.querySelector('summary, button, input'); if (f) f.focus({ preventScroll: true }); }
  }
  function sOpen(btn, on) {
    var wrap = btn ? btn.closest('.custom__sort') : null;
    document.querySelectorAll('[sort-body]').forEach(function (b) { var mine = wrap && wrap.contains(b); b.classList.toggle('open', !!(on && mine)); });
    document.querySelectorAll('[sort-opener]').forEach(function (o) { var mine = o === btn; o.classList.toggle('active', !!(on && mine)); o.setAttribute('aria-expanded', on && mine ? 'true' : 'false'); });
    // Mobile: the sort list is a bottom sheet, so dim the page and hold its scroll while it is open
    var open = !!(on && wrap), was = html.classList.contains('tk-sort-open');
    html.classList.toggle('tk-sort-open', open);
    if (open !== was) lockScroll(open && window.matchMedia('(max-width: 749px)').matches);
  }
  function fRender(url) {
    var qs = url.indexOf('?') > -1 ? url.split('?')[1] : '';
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) { FacetFiltersForm.renderPage(qs); return; }
    location.href = url;
  }
  if (!C.pass) document.addEventListener('click', function (e) {
    if (!(html.classList.contains('tk-col') || html.classList.contains('tk-srch'))) return;
    var t = e.target.closest ? e.target : null; if (!t) return;
    var acc = t.closest('#main-collection-filters .accordion-header, #main-search-filters .accordion-header');
    if (acc) {
      e.preventDefault(); e.stopPropagation();
      var g = acc.closest('.accordion-item'), lab = g.querySelector('[data-tk-raw]');
      var k = lab ? lab.getAttribute('data-tk-raw').toLowerCase() : '';
      var on = !g.classList.contains('active'); if (F_OPEN && k) F_OPEN[k] = on; fSetOpen(g, on);
      return;
    }
    var fo = t.closest('[filter-opener]'), hf = t.closest('[hide-filter]'), so = t.closest('[sort-opener]'), ca = t.closest('[clear-all-filter]');
    if (fo) { e.preventDefault(); e.stopPropagation(); sOpen(null, false); fOpen(!html.classList.contains('tk-filters-open')); return; }
    if (hf || t.closest('[data-tk-fscrim]')) { e.preventDefault(); e.stopPropagation(); sOpen(null, false); fOpen(false); return; }
    if (ca) {
      e.preventDefault(); e.stopPropagation();
      var all = document.querySelector('.active-facets__button-remove, .remove__all-filter');
      fRender(all ? all.getAttribute('href') : location.pathname + (new URLSearchParams(location.search).get('q') ? '?q=' + encodeURIComponent(new URLSearchParams(location.search).get('q')) : ''));
      return;
    }
    if (so) { e.preventDefault(); e.stopPropagation(); sOpen(so, so.getAttribute('aria-expanded') !== 'true'); return; }
    if (!t.closest('[sort-body]')) sOpen(null, false);
    else if (t.closest('label, input')) setTimeout(function () { sOpen(null, false); }, 120);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (html.classList.contains('tk-filters-open')) fOpen(false); sOpen(null, false); } });
  function initFilters() {
    if (C.pass || !(html.classList.contains('tk-col') || html.classList.contains('tk-srch'))) return;
    if (!document.querySelector('[data-tk-fscrim]')) document.body.insertAdjacentHTML('beforeend', '<div class="tk-fscrim" data-tk-fscrim></div>');
    fDecorate();
    // Re-decorate whenever the theme re-renders filters or the grid (filtering, sorting, paging, chip swaps)
    var main = document.getElementById('MainContent');
    if (main && 'MutationObserver' in window) {
      var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(fDecorate, 80); }).observe(main, { childList: true, subtree: true });
    }
  }

  /* ---------- orchestration ---------- */
  function renderAll() {
    renderPreview(); renderBar(); renderBand(); renderCards(); renderPdp(); renderBag();
  }
  var moTimer;
  var mo = new MutationObserver(function (muts) {
    var need = muts.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches('[data-tk-card],[data-tk-bag]') || n.querySelector && n.querySelector('[data-tk-card],[data-tk-bag]'));
      });
    });
    if (!need) return;
    clearTimeout(moTimer);
    moTimer = setTimeout(function () { renderCards(); renderBag(); }, 60);
  });
  function start() {
    renderAll();
    markActiveTab();
    initProductExtras();
    initBundle();
    hijackLiveDrawer();
    initFilters();
    var setHdr = function () { var h = document.querySelector('[data-tk-header]'); if (h) html.style.setProperty('--tk-hdr-h', h.offsetHeight + 'px'); };
    setHdr(); window.addEventListener('resize', setHdr);
    saveRecent();
    initRows(document);
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      if (t.closest('[data-tk-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
      if (t.closest('[data-tk-drawer-close]')) { closeDrawer(); return; }
      if (t.closest('[data-tk-search-open]')) { openSearch(); return; }
      if (t.closest('[data-tk-search-close]')) { closeSearch(); return; }
      if (t.closest('[data-tk-bag-open]')) { openBag(e); return; }
      var nav = t.closest('[data-tk-row-nav]');
      if (nav) { var tr = nav.parentNode.querySelector('.tk-row__track'); if (tr) tr.scrollBy({ left: +nav.getAttribute('data-tk-row-nav') * tr.clientWidth * 0.9, behavior: 'smooth' }); return; }
      var sb = t.closest('[data-tk-shopby-tab]');
      if (sb) {
        var wrap = sb.closest('[data-tk-shopby]'), row = wrap && wrap.querySelector('[data-tk-shopby-row]');
        wrap.querySelectorAll('[data-tk-shopby-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === sb ? 'true' : 'false'); });
        if (row) { row.setAttribute('data-src', sb.getAttribute('data-src')); row.className = 'tk-row'; loadRow(row); }
        return;
      }
      var hc = t.closest('[data-tk-home-chip]');
      if (hc && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); homeChip(hc); return; }
      var chip = t.closest('[data-tk-chip]');
      if (chip && !e.metaKey && !e.ctrlKey && !e.shiftKey && (html.classList.contains('tk-col') || html.classList.contains('tk-srch')) && chip.href && chip.origin === location.origin) {
        e.preventDefault(); swapTo(carryParams(chip.href), true);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });
    document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-tk-search-input]')) { clearTimeout(sugTimer); var v = e.target.value; sugTimer = setTimeout(function () { suggest(v); }, 140); } });
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('form[action$="/search"], [data-tk-search-form]')) return;
      var q = f.querySelector('[name="q"]'); if (q) { saveQ(q.value); if (SYN.length) q.value = rewrite(q.value); }
    }, true);
    loadBag();
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('form, variant-selects, variant-radios')) setTimeout(renderPdp, 60); });
    var lastV = currentVariantId();
    setInterval(function () {
      if (MAIN) document.querySelectorAll('[data-tk-clock]').forEach(function (c) { c.textContent = 'Ends in ' + countdown(MAIN.e - now()); });
      var v = currentVariantId(); if (v !== lastV) { lastV = v; renderPdp(); }
      var s2 = activeAt(now()); if ((s2.main && s2.main.id) !== (MAIN && MAIN.id)) location.reload(); // campaign handover
    }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.TK = { now: now, state: function () { return { main: MAIN && MAIN.id, ship: STATE.ship && STATE.ship.id, bag: BAG }; }, refresh: loadBag };
})();
